import {UniqueIdentifier} from '@dnd-kit/core';
import React, {memo} from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {Item} from './Item';
import {Portlet} from '../../../../components/Portlet';
import {Tile} from '../../../../components/Tile';
import {useMountStatus} from '../../../../hooks/useMountStatus';
import {HomepageItemData} from '../../../../api';

interface SortableItemProps {
    containerId: UniqueIdentifier;
    id: UniqueIdentifier;
    handle: boolean;
    disabled?: boolean;
    data?: HomepageItemData;
    style?: (args: any) => React.CSSProperties;
}

export const SortableItem = memo(
    ({
        disabled,
        id,
        handle,
        data,
        itemType
    }: SortableItemProps & {children?: React.ReactNode; itemType: string}) => {
        const {
            setNodeRef,
            setActivatorNodeRef,
            listeners,
            isDragging,
            isSorting,
            transform,
            transition,
            active
        } = useSortable({
            id,
            data: {
                itemType
            }
        });

        const mounted = useMountStatus();
        const mountedWhileDragging = isDragging && !mounted;

        if (!data) {
            return null;
        }

        const isActive = active?.id === data.exec;

        return (
            <Item
                ref={disabled ? undefined : setNodeRef}
                value={id}
                dragging={isDragging}
                sorting={isSorting}
                handle={handle}
                handleProps={handle ? {ref: setActivatorNodeRef} : undefined}
                transition={transition}
                transform={transform}
                fadeIn={mountedWhileDragging}
                listeners={listeners}
                isActive={isActive}
                disabled={data.disabled === '1'}
            >
                {data.type === 'p' ? <Portlet {...data} /> : <Tile {...data} />}
            </Item>
        );
    }
);
